/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import FabAddButton from '../../components/Buttons/FabAddButton';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { useDispatch, useSelector } from 'react-redux';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { history } from '../../core/history';
import { store } from '../../core/store';
import { newPlatformResellerReducers, newPlatformResellerReducersType } from '../../modules/newplatformreseller/newReducers';
import { makeStyles } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import PlatformResellerList, { ResellerMapItem } from './Components/PlatformResellerList';
import { TreeNode } from 'react-hyper-tree/dist/helpers/node';
import i18n from 'i18next';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { AlertDialog } from '../lib/dialog/AlertDialog';
import I18n from '../../core/i18n';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { platformResellerConstants } from '../../modules/platformreseller/actions';
import PlatformResellerInterface from '../../interfaces/platform/PlatformResellerInterface';
import Filter from '../../interfaces/forms/Filter';
import { newPlatformResellerConstants } from '../../modules/newplatformreseller/actions';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import { Auth } from '../../modules/auth/Auth';
import Loader from '../../components/Loaders/Loader';

store.injectReducer('newPlatformResellerReducers', newPlatformResellerReducers);

const useStyles = makeStyles(adescomStyle);

const _ = require('underscore');

export const PlatformReseller = (): React.ReactElement => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const mainUrl = '/platform_resellers';
    const { resellerList } = useSelector(
        (state: { newPlatformResellerReducers: newPlatformResellerReducersType }) => state.newPlatformResellerReducers
    );
    const [formattedResellerList, setFormattedResellerList] = useState<ResellerMapItem[]>([]);

    const [selectedNode, setSelectedNode] = useState<TreeNode | null>(null);
    const [selectedDeleteNode, setSelectedDeleteNode] = useState<TreeNode | null>(null);
    const [selectedReinstateNode, setSelectedReinstateNode] = useState<TreeNode | null>(null);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState<string>('');
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [alertMessageValueObject, setAlertMessageValueObject] = useState<object>({});
    const [visibleLoader, setVisibleLoader] = useState<boolean>(false);

    const retrieveResellerList = useCallback(
        (url: string | null = null): void => {
            // const filter: Array<Filter> = baseDeletedFilter ? [baseDeletedFilter] : [];
            const filter: Array<Filter> = [];

            url = FormGeneralHelper.getUrl(mainUrl);

            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                url,
                newPlatformResellerConstants.NEW_PLATFORM_RESELLER_LIST,
                filter,
                [],
                (collections: PlatformResellerCollectionInterface) => {
                    dispatch({ type: newPlatformResellerConstants.NEW_PLATFORM_RESELLER_LIST, resellerList: collections });
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                    dispatchErrorAfterCallback: true,
                }
            );
        },
        [dispatch /**, baseDeletedFilter**/]
    );

    useEffect(() => {
        retrieveResellerList();
    }, [retrieveResellerList]);

    const findItem = useCallback((map: Array<ResellerMapItem>, item: ResellerMapItem): ResellerMapItem | null => {
        let parent: ResellerMapItem | null = null;
        map.forEach((subItem: ResellerMapItem) => {
            let deepItem: ResellerMapItem | null = null;
            if (subItem.children.length > 0) {
                deepItem = findItem(subItem.children, item);
            }

            if (deepItem && deepItem.id === item.parentResellerId) {
                parent = deepItem;
            }

            if (subItem.id === item.parentResellerId) {
                parent = subItem;
            }
        });

        return parent;
    }, []);

    useEffect((): void => {
        const resellerMap: ResellerMapItem[] = [];
        if (!resellerList || !resellerList['hydra:member']) {
            return;
        }

        let rootElements = 0;

        _.each(resellerList['hydra:member'], (item: PlatformResellerInterface) => {
            const parentResellerId = item.parentResellerId && Auth.getUserPlatformResellerId() !== item.id ? item.parentResellerId : -1;
            if (parentResellerId === -1) {
                rootElements++;
            }
            const mapItem = {
                id: item.id,
                name: item.mainname,
                parentResellerId: item.parentResellerId,
                children: [],
                resellerObject: item,
            } as ResellerMapItem;
            resellerMap.push(mapItem);
        });

        let iterationLimit = 500;
        while (resellerMap.length > rootElements) {
            resellerMap.forEach((item: ResellerMapItem, index: number) => {
                if (item.parentResellerId) {
                    const tmpObj = findItem(resellerMap, item);

                    if (tmpObj) {
                        tmpObj.children.push(item);
                        resellerMap.splice(index, 1);
                    }
                }
            });
            iterationLimit--;
            if (iterationLimit <= 0) {
                console.error('Reseller Iteration Limit threshold reached');
                return;
            }
        }

        if (visibleLoader) {
            setVisibleLoader(false);
        }
        setFormattedResellerList(resellerMap);
    }, [resellerList, findItem, visibleLoader, setVisibleLoader]);

    const addNewPlatformReseller = (): void => {
        if (!selectedNode) {
            NotificationHelper.notifyError('general:common.select_reseller', dispatch);
            return;
        }

        const data = selectedNode.data;
        history.push(FormGeneralHelper.getRouteUrl(`/platform-reseller-add/${data.resellerObject.id}`));
    };

    const closeAlert = (): void => {
        setAlertOpen(false);
        setAlertTitle('');
        setAlertMessage('');
        setSelectedDeleteNode(null);
        setSelectedReinstateNode(null);
        setAlertMessageValueObject({});
    };

    const editButtonCallback = (node: TreeNode): void => {
        const data = node.data;
        // componentDebug('Hit edit button ' + data.resellerObject['@id']);
        const uri = FormGeneralHelper.getRouteUrl('/platform-reseller-edit/' + data.resellerObject['@id']);
        // // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // // @ts-ignore
        history.push(uri);
    };

    const handleManageUsers = (node: TreeNode): void => {
        const data = node.data;
        const uri = FormGeneralHelper.getRouteUrl('/platform-user-list/' + data.resellerObject.id);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.push(uri);
    };

    const handleNumberRangeEdit = (node: TreeNode): void => {
        const data = node.data;
        const uri = FormGeneralHelper.getRouteUrl('/number-range-edit/' + data.resellerObject.id);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.push(uri);
    };

    const handleDeleteConfirm = (): void => {
        const uri = FormGeneralHelper.getUrl('/platform_resellers', 'platform') + '/' + selectedDeleteNode?.data.resellerObject.id;
        const itemLoaders = new ItemLoaders(dispatch);
        setVisibleLoader(true);
        itemLoaders.deleteWithCallback(
            uri,
            platformResellerConstants.PLATFORM_RESELLER_DELETE,
            {
                onSuccess: (data: any) => {
                    NotificationHelper.notifySuccess('platform_reseller:pr.deleted_success', dispatch);
                    retrieveResellerList();
                    closeAlert();
                },
                onError: () => {
                    setVisibleLoader(false);
                    closeAlert();
                },
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
                dispatchErrorAfterCallback: true,
            }
        );
    };

    const handleReinstateConfirm = (): void => {
        const uri = FormGeneralHelper.getUrl('/platform_resellers', 'platform') + '/' + selectedReinstateNode?.data.resellerObject.id;
        const itemLoaders = new ItemLoaders(dispatch);
        setVisibleLoader(true);
        itemLoaders.putWithCallback(
            uri,
            platformResellerConstants.PLATFORM_RESELLER_EDIT,
            { deleted: 0 },
            {
                onSuccess: (data: any) => {
                    NotificationHelper.notifySuccess('platform_reseller:pr.reinstate_success', dispatch);
                    retrieveResellerList();
                    closeAlert();
                },
                onError: () => {
                    setVisibleLoader(false);
                    closeAlert();
                },
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
                dispatchErrorAfterCallback: false,
            }
        );
    };

    const handleDelete = (node: TreeNode): void => {
        setSelectedDeleteNode(node);
        setAlertTitle('platform_reseller:pr.delete_platform_reseller');
        setAlertMessage('platform_reseller:pr.delete_confirm');
        setAlertMessageValueObject({ resellerName: node.data.resellerObject.mainname });
        setAlertOpen(true);
    };

    const handleReinstate = (node: TreeNode): void => {
        setSelectedReinstateNode(node);
        setAlertTitle('platform_reseller:pr.reinstate_platform_reseller');
        setAlertMessage('platform_reseller:pr.reinstate_confirm');
        setAlertMessageValueObject({ resellerName: node.data.resellerObject.mainname });
        setAlertOpen(true);
    };

    const handleSelect = (node: TreeNode): void => {
        setSelectedNode(node);
    };

    return (
        <GridContainer>
            <GridItem xs={12}>
                <PlatformResellerList
                    showActions={true}
                    handleDelete={handleDelete}
                    handleSelect={handleSelect}
                    handleReinstate={handleReinstate}
                    formattedResellerList={formattedResellerList}
                    handleEdit={editButtonCallback}
                    handleManageUsers={handleManageUsers}
                    handleNumberRangeEdit={handleNumberRangeEdit}
                />
            </GridItem>
            <FabAddButton callback={addNewPlatformReseller} />
            <AlertDialog
                open={alertOpen}
                titleDialog={alertTitle}
                displayMessage={alertMessage}
                displayMessageValueObject={alertMessageValueObject}
                closeCallback={closeAlert}
                confirmCallback={selectedReinstateNode ? handleReinstateConfirm : handleDeleteConfirm}
            />
            <Loader visible={visibleLoader} />
        </GridContainer>
    );
};

export default PlatformReseller;
